import axios from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createInstallmentSlice = (set, get) => ({
    installment: {
        loading: false,
        filter: {},
        data: {
            Installments: [],
            TotalCount: 0,
            TotalAmount: 0
        },
        error: null,
    },
    getInstallmentInfo: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({
            installment: {
                ...state.installment,
                loading: true,
                filter: param,
                error: null,
            }
        }));

        try {
            const data = {};
            if (param.fromDate) data.fromDate = param.fromDate;
            if (param.toDate) data.toDate = param.toDate;
            if (param.branchIds && param.branchIds.length > 0) data.branchIds = param.branchIds;
            if (param.userId && param.userId !== 0) data.userId = param.userId;
            if (param.username) data.username = param.username;
            data.pageSize = param.pageSize ?? 10;
            data.pageIndex = param.pageIndex ?? 0;

            const resp = await axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/installment",
                data,
                headers: { token },
            });

            set(state => ({
                installment: {
                    ...state.installment,
                    loading: false,
                    data: resp.data || { Installments: [], TotalCount: 0, TotalAmount: 0 },
                    error: null,
                }
            }));
        } catch (error) {
            set(state => ({
                installment: {
                    ...state.installment,
                    loading: false,
                    data: { Installments: [], TotalCount: 0, TotalAmount: 0 },
                    error: error?.response?.data?.Message || error?.message || "خطا در دریافت اطلاعات اقساط",
                }
            }));
        }
    },
    clearInstallmentData: () => {
        set(state => ({
            installment: {
                loading: false,
                filter: {},
                data: { Installments: [], TotalCount: 0, TotalAmount: 0 },
                error: null,
            }
        }));
    },
});
